export default "__VITE_ASSET__BUGGUBMp__"